/* eslint-disable */
import { createRouter, createWebHashHistory } from 'vue-router'
// import Config from '@/conf/Config.js'

let routes = [
    {
        path: '/:catchAll(.*)',
        redirect: '/404'
    },
    {
        path: '/404',
        component: () => import("@/views/public/NoPage.vue"),
        name: "404",
        meta: {
            auth: false,
            title : "Not Found",
            icon: "fa fa-magic",
            closable: true
        }
    },
    // Untuk admin
    {
        path: "/login",
        name: "AdminLogin",
        component: () => import("@/views/public/AdminLogin.vue"),
        meta: {
            auth: false,
            title : 'AdminLogin'
        },
    },
    // Untuk admin
    {
        path: "/",
        name: "Main",
        component: () => import('@/views/admin/Main.vue'),
        meta: {
            auth: true,
            title : 'Dashboard',
            tips: 'Dashboard',
            icon: 'fa fa-home', 
            closable: false,
            tabClass: 'w3-theme-l1',
        },
        children: [
            {
                path: '*',
                component: () => import("@/views/public/NoPage.vue"),
                name: "NoPageAnak",
                meta: {
                    auth: false,
                    title : "Not Found",
                    icon: "fa fa-magic",
                    closable: true
                }
            },
        ]
    }
];

// Untuk menu Klinik
// console.log('routes 1', routes[4]);

import mixin from  '../mixin.js';

async function setMenuAwal(){
    if (localStorage.adminPmbDB !=undefined){
        const menusdetail = JSON.parse(mixin.methods.DeCompresString(localStorage["PmsDbMenus"]));
        for (let index = 0; index < menusdetail.length; index++) {
            let element = menusdetail[index];        
            routes[3].children.push(
                {
                    path: element["path"],
                    name: element["name"],
                    urlimport : element["urlimport"] ,
                    component: () => import(`@/${element["urlimport"]}`),
                    meta: element["meta"]
                }
            );
        }        
    }
}

setMenuAwal();


console.log('routes 2', routes[3]);

const router = createRouter({
    history: createWebHashHistory(), //createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    try {
        // console.log("Ke to ",to);
        if ( to.name == null){
            next("/login");
        }
        if (to.matched.some(record => record.meta.auth)) {
            // console.log("record");
            vm.checkLogin(function(res){
                if (res.success == true) {
                    // console.log("Check Login", localStorage.program);
                    if (localStorage.program=="" || localStorage.program==undefined){
                        if (to.fullPath!="/login"){
                            next("/login");
                        }else{
                            next();
                        }
                    }else{
                        if(to.fullPath=="/"){
                            next("/" + localStorage.program + "Dashboard");
                        }else{
                            next();
                        }
                    }
                }else{
                    next("/login");
                }
            }, function(err){
                next("/login");
            });
        } else {
            next();            
        }
    } catch (error) {
        next("/login");
        console.log('router error1', error);
    }
});

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        // NProgress.start();
        // this.showLoading("Loading ..");
        document.getElementById('txt-loading').innerHTML = "Loading ..";
        document.getElementById('idLoading').style.display='block';
    }
    next()
});


router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.
    // NProgress.done()
    document.getElementById('idLoading').style.display='none';
});

export default router
